<template>
	<div class="fullscreen-layout">
		<transition name="fade" mode="out-in" appear>
			<slot/>
		</transition>
	</div>
</template>

<script>
// @ is an alias to /src

export default {
}
</script>

<style>
.fullscreen-layout {
	position: relative;
	overflow: auto;
	width: 100%;
	height: 100%;
}
</style>